import { z } from "zod";

export const GetAudioCourseEpisodeUrlSchema = z.object({
  audioCourseId: z.string().min(1),
});

export type GetAudioCourseEpisodeUrlPostBody = z.infer<typeof GetAudioCourseEpisodeUrlSchema>;
